// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oXYdDWt4eLjEhgi_eYQQ{max-width:1200px;padding-bottom:10px}`, "",{"version":3,"sources":["webpack://./modules/SitPanel/components/SitPanelReports/SitPanelReports.module.scss"],"names":[],"mappings":"AAEA,sBACC,gBAAA,CACA,mBAAA","sourcesContent":["@import \"../../../../assets/scss/variables\";\r\n\r\n.SitPanelReportsDateRange {\r\n\tmax-width: 1200px;\r\n\tpadding-bottom: 10px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"SitPanelReportsDateRange": `oXYdDWt4eLjEhgi_eYQQ`
};
export default ___CSS_LOADER_EXPORT___;
